"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CalendarDateUtility {
    static _mapIntoDoubleDigit(input) {
        const inputNumber = input;
        if (inputNumber < 10 && !isNaN(inputNumber)) {
            return '0' + inputNumber;
        }
        return inputNumber.toString();
    }
    static getNumOfDaysInMonth(inputDate) {
        return new Date(inputDate.getFullYear(), inputDate.getMonth() + 1, 0).getDate();
    }
    static getDateString(inputDate) {
        const month = this._mapIntoDoubleDigit(inputDate.getMonth() + 1);
        const day = this._mapIntoDoubleDigit(inputDate.getDate());
        const year = inputDate.getFullYear();
        return month + '-' + day + '-' + year;
    }
    static getDateObject(dateString) {
        const dateTimeParts = dateString.trim().split('-');
        const month = parseInt(dateTimeParts[0], 10);
        const day = parseInt(dateTimeParts[1], 10);
        const year = parseInt(dateTimeParts[2], 10);
        return new Date(year, (month - 1), day);
    }
    static getDateInfoString(dateString) {
        const dateTimeParts = dateString.trim().split('-');
        const monthOfYear = parseInt(dateTimeParts[0], 10);
        const dayOfMonth = parseInt(dateTimeParts[1], 10);
        const year = parseInt(dateTimeParts[2], 10);
        return {
            month: monthOfYear,
            year: year,
            day: dayOfMonth
        };
    }
    static getWeekDayInCalendarLocale(weekDay, calendarLocaleWeekStartDay) {
        return (weekDay - calendarLocaleWeekStartDay + 7) % 7;
    }
}
exports.default = CalendarDateUtility;
